// lib
import React, { useContext } from 'react'
import PropTypes from 'prop-types'
import { Map } from 'immutable'

import { DataContext } from '@aytm/app/stats/page/sidebar/filters/FiltersPanel'

// components
import SidebarPopup from '@aytm/app/stats/page/sidebar/components/SidebarPopup'

import AdvancedFilterContainer from '@aytm/app/stats/page/components/AdvancedFilterContainer'

// styles
import style from '@aytm/app/stats/page/sidebar/filters/styles/FiltersPanel.module.scss'

const FiltersAdvanced = ({ parser, locale, surveySchema, clusters, parserResultEof }) => {
  const { root, features, state, disabled, onChangeAdvancedFilter } = useContext(DataContext)

  return (
    <div className={`${style['advanced-container']} p-field p-col-12`}>
      <div className={style['filter-header']}>
        <span className={style['filter-title']}>CUSTOM FILTERS</span>
        <SidebarPopup
          root={root}
          help='Custom filters give you a greater control over filtering conditions, such as using an "OR" operator, grouping conditions in parentheses etc. You can define your desired filtering criteria using the standard aytm Logic expressions (without square brakets). For example, <b>Q1A1</b> or <b>Q2A1</b>. Option to switch back to the basic mode will be available as long as your filter expression is supported by our user interface. Once filter becomes too complex, you will be able to continue using the advanced mode only.'
        />
      </div>
      <AdvancedFilterContainer
        pattern={state.advanced}
        parser={parser}
        locale={locale}
        surveySchema={surveySchema}
        clusters={clusters}
        parserResultEof={parserResultEof}
        hintPosition="bottom"
        disabled={disabled || features.advanced.disabled}
        onChange={disabled || features.advanced.disabled ? null : onChangeAdvancedFilter}
      />
    </div>
  )
}

FiltersAdvanced.propTypes = {
  parser: PropTypes.any,
  locale: PropTypes.instanceOf(Map),
  surveySchema: PropTypes.object,
  clusters: PropTypes.object,
  parserResultEof: PropTypes.object.isRequired
}

FiltersAdvanced.displayName = 'FiltersAdvanced'

export default FiltersAdvanced
